/*
Defines the custom element
*/

import { RavelMessageBridge } from './src/RavelMessageBridge.js';

customElements.define('ravel-message-bridge', RavelMessageBridge);
